import { FacetCountsDTO } from "./filters.type";

export const mapFacetCounts = (results: FacetCountsDTO) => {
  const counts = results.facetItems.map((item) => ({
    filterKey: item.key,
    filterValues: item.values.map((val) => ({
      name: val.description,
      count: val.count,
    })),
  }));

  return {
    counts,
    totalResults: results.totalResults,
  };
};
